// 电子社保卡申领——微信，主流程
const wxMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `apply/wx/index${i + 1}`,
  name: `applyWxIndex${i + 1}`,
  component: () => import(`@/views/society/apply/wx/index${i + 1}.vue`)
}))

// 电子社保卡申领——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `apply/zfb/index${i + 1}`,
  name: `applyZfbIndex${i + 1}`,
  component: () => import(`@/views/society/apply/zfb/index${i + 1}.vue`)
}))

// 电子社保卡申领——皖事通，主流程
const wstMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `apply/wst/index${i + 1}`,
  name: `applyWstIndex${i + 1}`,
  component: () => import(`@/views/society/apply/wst/index${i + 1}.vue`)
}))

export default {
  path: '/society',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 电子社保卡申领——微信，开始
    ...wxMainRoutes,

    // 电子社保卡申领——支付宝，主流程
    ...zfbMainRoutes,

    // 电子社保卡申领——皖事通，主流程
    ...wstMainRoutes,
  ]
}
